/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AccountIsPartnerQueryVariables = GraphQL.Exact<{
  accountId: GraphQL.Scalars['AccountId']['input'];
}>;


export type AccountIsPartnerQuery = { readonly __typename?: 'Query', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId, readonly isPartner: boolean } | null };


export const AccountIsPartnerDocument = gql`
    query AccountIsPartner($accountId: AccountId!) {
  account(id: $accountId) {
    id
    isPartner
  }
}
    `;

/**
 * __useAccountIsPartnerQuery__
 *
 * To run a query within a React component, call `useAccountIsPartnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountIsPartnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountIsPartnerQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountIsPartnerQuery(baseOptions: Apollo.QueryHookOptions<AccountIsPartnerQuery, AccountIsPartnerQueryVariables> & ({ variables: AccountIsPartnerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountIsPartnerQuery, AccountIsPartnerQueryVariables>(AccountIsPartnerDocument, options);
      }
export function useAccountIsPartnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountIsPartnerQuery, AccountIsPartnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountIsPartnerQuery, AccountIsPartnerQueryVariables>(AccountIsPartnerDocument, options);
        }
export function useAccountIsPartnerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountIsPartnerQuery, AccountIsPartnerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountIsPartnerQuery, AccountIsPartnerQueryVariables>(AccountIsPartnerDocument, options);
        }
export type AccountIsPartnerQueryHookResult = ReturnType<typeof useAccountIsPartnerQuery>;
export type AccountIsPartnerLazyQueryHookResult = ReturnType<typeof useAccountIsPartnerLazyQuery>;
export type AccountIsPartnerSuspenseQueryHookResult = ReturnType<typeof useAccountIsPartnerSuspenseQuery>;
export type AccountIsPartnerQueryResult = Apollo.QueryResult<AccountIsPartnerQuery, AccountIsPartnerQueryVariables>;